// @flow
import type { Dispatch } from 'redux';
import { connect } from 'react-redux';
import type { State, Actions } from '../store';
import Permissions from '../components/Permissions';
import {
  actions as permissionActions,
  selectors as permissionSelectors
} from '../store/permissions';
import {
  actions as newsletterUriActions,
  selectors as newsletterUriSelectors
} from '../store/newsletterUri';

const mapStateToProps = ({ permissionReducer, newsletterUriReducer, appReducer }: State, { match }) => {
  const permissions = permissionSelectors.selectPermissionsByProductId(
    permissionReducer,
    match.params.prodId
  );

  const product = permissionSelectors.selectPermissionById(
    permissionReducer,
    match.params.prodId
  );

  const newsletterUri = newsletterUriSelectors.selectNewsletterUri(newsletterUriReducer);

  return {
    error: permissionReducer.error,
    isFetching: permissionReducer.isFetching,
    isSaving: permissionReducer.isChannelPosting,
    savingError: permissionReducer.channelError,
    userPermission: permissionSelectors.selectUserPermissionByPermissionId(permissionReducer, product.id),
    allAllowed: product.allowed && Object.values(product.allowed).some((value) => value),
    product,
    newsletterUri,
    permissions: permissions.length ? permissions : [product],
    brand: appReducer.brand
  };

};
const mapDispatchToProps = (dispatch: Dispatch<Actions>, { userId }) => ({
  fetchPermissions: () => dispatch(permissionActions.fetchPermissions(userId)),
  setAllPermissions: (product, value, userPermission) =>
    dispatch(permissionActions.setChannel(product, '', value, userPermission)).then(() =>
      dispatch(permissionActions.fetchPermissions(userId))
    ),
  setPermission: (permission, value, userPermission) =>
    dispatch(permissionActions.setChannel(permission, '', value, userPermission)).then(() =>
      dispatch(permissionActions.fetchPermissions(userId))
    ),
  getNewsletterUri: () => dispatch(newsletterUriActions.getNewsletterUri())
});
const PermissionContainer = connect(mapStateToProps, mapDispatchToProps)(
  Permissions
);

export default PermissionContainer;
